<template>
    <div class="event-step-nav">
        <div
            v-for="item in steps"
            :key="item.key"
            :class="['event-step-nav__item', value === item.key && 'event-step-nav__item--active', item.locked && 'event-step-nav__item--locked']"
            :title="item.locked ? langJson(item.lockedHint) : ''"
            @click="!item.locked && $emit('input', item.key)"
        >
            <GI :name="item.icon" ws="24" hs="24"></GI>
            <span class="event-step-nav__label">{{ langJson(item.label) }}</span>
            <span v-if="item.done" class="event-step-nav__done">✓</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: { type: String, required: true },
        // [{ key, label, icon, done?, locked?, lockedHint? }]
        steps: { type: Array, required: true },
    },
}
</script>
<style lang="scss" scoped>
.event-step-nav {
    background: var(--color_white);
    border-radius: 32px;
    padding: 24px;
    box-sizing: border-box;
    box-shadow: 4px 8px 24px rgba(187, 196, 221, 0.08);
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__item {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 52px;
        padding: 0 22px;
        border: 2px solid transparent;
        border-radius: 32px;
        cursor: pointer;
        white-space: nowrap;

        &--active {
            background-clip: padding-box, border-box;
            background-origin: padding-box, border-box;
            background-image: linear-gradient(to right, var(--color_white), var(--color_white)), linear-gradient(180deg, var(--modif_color) 0%, var(--main_color) 100%);

            .event-step-nav__label {
                background: linear-gradient(180deg, var(--modif_color) 0%, var(--main_color) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                font-weight: 700;
            }
        }
        &--locked {
            cursor: not-allowed;
            opacity: 0.45;
        }
    }
    &__label {
        font-family: 'Lato';
        font-size: 16px;
        line-height: 24px;
        color: var(--font_modif_color);
        flex: 1;
    }
    &__done {
        color: #12a150;
        font-weight: 700;
    }
}

// Phone: a horizontal pill scroller above the form.
@media only screen and (max-width: 1080px) {
    .event-step-nav {
        flex-direction: row;
        overflow-x: auto;
        padding: 8px;
        gap: 8px;
        border-radius: 24px;

        &__item {
            height: 40px;
            padding: 0 14px;
            flex-shrink: 0;
        }
        &__label {
            font-size: 14px;
        }
    }
}
</style>
